









import { defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';
import { FlowControlModeOptionItem } from '../types';

const name = 'ttam-delivery-type-plain-option';

export default defineComponent({
  name,
  props: {
    option: {
      type: Object as PropType<FlowControlModeOptionItem>,
      default: () => ({}),
    },
  },
  setup() {
    return {
      name,
    };
  },
});
